var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{ref:"container"},[_c('ArtisanGrid',{ref:"msgRecord",attrs:{"metaKey":"JcMsgRecord","metaInited":_vm.metaInited},on:{"resend":_vm.resend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }